import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';

import AboutSearchDetails from './AboutSearch/AboutSearchDetails';
import CircleMap from './AboutSearch/CircleMap';
import PanelWithTitleAndIcon from '../../common/PanelWithTitleAndIcon';
import RemainingTimeCircle from './AboutSearch/RemainingTimeCircle';

import { Search } from '../MatchModel';
import tr from '../../localization/translate';

import aboutSearchIcon from '../../assets/images/about-search.svg';
import s from './AboutSearch.scss';

const nameClassName = `effra rem_1_25 ${s.name}`;

function ToggleArrow({ open }) {
  return (
    <svg viewBox="0 0 22 12" className={classNames(s.arrow, { [s.arrow_open]: open })}>
      <path d="M1 1.116L10.941 11 21 1" />
    </svg>
  );
}

ToggleArrow.propTypes = { open: PropTypes.bool.isRequired };


function TimeAndName({ search }) {
  return (
    <div styleName="time_and_name">
      <i styleName="pre_circle_spacer" />
      <RemainingTimeCircle from={search.purchased} to={search.expires} />
      <i styleName="post_circle_spacer" />
      <h2 className={nameClassName}>{ search.name }</h2>
    </div>
  );
}

TimeAndName.propTypes = { search: Search.propType.isRequired };


function TitleSection({ asButton, onSelectSearch, open, search }) {
  if (asButton) {
    return (
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        data-id={search.search_id}
        onClick={onSelectSearch}
        styleName="time_and_name_with_button_wrapper"
      >
        <TimeAndName search={search} />

        <button className="naked_button" styleName="expand_button" type="button">
          <ToggleArrow open={open} />
        </button>
      </div>
    );
  }

  return (<TimeAndName search={search} />);
}

TitleSection.propTypes = {
  asButton: PropTypes.bool.isRequired,
  onSelectSearch: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  search: Search.propType.isRequired
};


class AboutSearch extends PureComponent {
  constructor(props) {
    super(props);

    this.openSearch = this.openSearch.bind(this);

    this.state = {
      openSearch: props.searches.size ? props.searches.first().search_id : ''
    };
  }

  get title() {
    if (this.props.asSharedProfile) {
      return tr('simple_pages.share_profile.about_search.title', {
        count: this.props.searches.size
      });
    }

    return tr('matching.about_search.title', { count: this.props.searches.size });
  }

  get noteText() {
    if (this.props.searches.size > 1) {
      return tr('matching.about_search.title_note', {
        count: this.props.searches.size
      });
    }

    return '';
  }

  openSearch(e) {
    const id = e.currentTarget.dataset.id;

    if (id === this.state.openSearch) {
      this.setState({ openSearch: '' });
    } else {
      this.setState({ openSearch: id });
    }
  }

  render() {
    return (
      <PanelWithTitleAndIcon icon={aboutSearchIcon} title={this.title} note={this.noteText}>
        { this.props.searches.map(search => {
          const open = (this.props.searches.size === 1) ||
            (this.state.openSearch === search.search_id);

          return (
            <div styleName="circle" key={search.search_id}>
              <TitleSection
                asButton={this.props.searches.size > 1}
                onSelectSearch={this.openSearch}
                open={open}
                search={search}
              />

              <div className={classNames(s.details, { [s.details_open]: open })}>
                <AboutSearchDetails search={search} />

                <CircleMap
                  styleName="map"
                  progress={search.remainingTimePercentage}
                  radius={search.radius}
                  circlePosition={search.gpoint}
                />
              </div>
            </div>
          );
        }) }
      </PanelWithTitleAndIcon>
    );
  }
}

AboutSearch.propTypes = {
  searches: ImmutablePropTypes.listOf(Search.propType).isRequired,
  asSharedProfile: PropTypes.bool
};

AboutSearch.defaultProps = {
  asSharedProfile: false
};

export default AboutSearch;
